import { CreateAuditTemplateRequest } from 'src/types/helios/AuditTemplate';
import { apiHeliosClient } from 'src/data/api/apiHeliosClient';
import {
  CreateAuditTemplateCommand,
  ListAuditTemplatesCommand,
  ListAuditTemplatesCommandInput,
  UpdateAuditTemplateCommand,
  UpdateAuditTemplateCommandInput,
} from '@amzn/gbsa-helios-typescript-client';

export const templateService = {
  // Get all templates
  getAll: (data: ListAuditTemplatesCommandInput) => {
    return apiHeliosClient.send(new ListAuditTemplatesCommand(data));
  },

  // Create new template
  create: (data: CreateAuditTemplateRequest) => {
    return apiHeliosClient.send(new CreateAuditTemplateCommand(data));
  },

  // Update template
  update: (data: UpdateAuditTemplateCommandInput) => {
    return apiHeliosClient.send(new UpdateAuditTemplateCommand(data));
  },
};
